<template>
  <v-col cols="12">
    <v-card text color="grey lighten-4">
      <v-card-text>
        <h3 class="pb-3">{{ title }}</h3>
        <v-row>
          <v-col
            class="d-flex"
            cols="4"
            sm="3"
            md="2"
            v-for="issue in issues"
            :key="issue.id"
            @click="selectIssue(issue.id)"
          >
              <issue-card :issue="issue"></issue-card>
          </v-col>
        </v-row>
      </v-card-text>
    </v-card>
  </v-col>
</template>

<script>
  import IssueCard from './IssueCard'
  export default {
    name: 'issue-block',
    components: { IssueCard },
    data () {
      return {}
    },
    props: ['issues', 'title'],
    methods: {
      selectIssue (id) {
        this.$emit('selectIssue', id)
      }
    }
  }
</script>
